import React from 'react';
import ReactPlayer from 'react-player';

const VideoPlayer = ({ url }) => <ReactPlayer width="100%" height="100%" url={url} controls />;

export default VideoPlayer;
